import React, { PureComponent } from 'react';
import Avatar from 'react-avatar';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import { styled } from '@mui/system';

const StyledMenu = styled(Menu)({
    '& .MuiPaper-root': {
        borderRadius: 8,
        minWidth: 240
    }
});

const BlockRow = styled('div')(({ theme, blank }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Theme.colors.surface,
    flex: 1,
    height: 60,
    minWidth: 400,
    marginBottom: 5,
    padding: 15,
    borderLeft: `5px solid ${ Theme.colors.surface }`,
    '&:hover': {
        backgroundColor: Theme.colors.backgroundGrey,
        borderLeft: `5px solid ${ Theme.colors.skyBlue }`
    },
    [theme.breakpoints.down('830')]: {
        flexDirection: !blank && 'column',
        height: !blank && 'auto',
        minWidth: !blank && 'unset',
        alignItems: !blank && 'start',
        display: !blank && 'none'
    }
}));

const Row50 = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '50%',
    [theme.breakpoints.down('830')]: {
        width: '100%'
    }
}));

class MemberRow extends PureComponent {
    state = {
        anchorEl: null
    };

    _handleMenuClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    _handleCloseMenu = () => {
        this.setState({ anchorEl: false });
    };

    render() {
        const { employee, change, remove, blank } = this.props;
        const { firstname, lastname, email, access } = employee;

        const styles = {
            spacer: {
                height: 50,
                width: 50
            },
            nameBlock: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height: '100%',
                padding: 10,
                width: '100%'
            },
            access: {
                display: 'flex',
                flexDirection: 'row',
                marginRight: 'auto',
                alignItems: 'center'
            }
        };

        const name = `${ firstname } ${ lastname }`;

        return (
            <BlockRow blank id="testing">
                <Row50>
                    {
                        !blank ?
                            <Avatar
                                name={name}
                                size="40"
                                textSizeRatio={2.2}
                                round
                                color={ Theme.colors.skyBlue }
                            />
                            : 
                            <div style={styles.spacer}></div>
                    }
                    <div style={styles.nameBlock}>
                        <Text
                            bold={blank}
                            medium
                        >
                            {name}
                        </Text>

                        <Text
                            light
                            small
                            color={ Theme.colors.mediumGrey }
                        >
                            { email }
                        </Text>
                    </div>
                </Row50>      

                <Row50>
                    <div style={styles.access}>
                        <Text
                            bold={blank}
                            medium
                        >
                            { access }
                        </Text>
                    </div>

                    {
                        !blank ?
                            <IconButton
                                aria-label="replace"
                                onClick={ this._handleMenuClick }
                                sx={{ color: `${ Theme.colors.darkGrey }` }}
                            >
                                <MoreVertIcon/>
                            </IconButton>
                            : 
                            <div style={styles.spacer}></div>
                    }

                    {/* TODO: export a styled menu component ui library */}

                    <StyledMenu
                        anchorEl={ this.state.anchorEl }
                        open={ Boolean(this.state.anchorEl) }
                        onClose={ this._handleCloseMenu }
                        onClick={ this._handleCloseMenu }
                        disableAutoFocusItem={ true }
                        anchorOrigin={ { vertical: "top", horizontal: "left" } }
                    >
                        <MenuItem onClick={ change }>
                            <Text
                                medium
                                display="inline"
                            >
                                Change Permission
                            </Text>
                        </MenuItem>
                        <MenuItem onClick={ remove }>
                            <Text
                                medium
                                display="inline"
                            >
                                Remove Member
                            </Text>
                        </MenuItem>
                    </StyledMenu>
                </Row50>
            </BlockRow>
        );
    }
}

export default MemberRow;